var _path, _path2, _path3, _path4, _g, _ellipse;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssetsCoinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.1795 17C32.1795 25.8362 25.1994 33 16.5897 33C7.98012 33 1 25.8362 1 17C1 8.16379 7.98012 1 16.5897 1C25.1994 1 32.1795 8.16379 32.1795 17Z",
    fill: "#1B4458"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1321 24.502H17.0453C17.2981 24.502 17.5024 24.2923 17.5024 24.0329V22.5517C19.3896 22.2443 20.5949 20.8961 20.5949 19.2304C20.5949 17.0384 19.2952 16.3024 16.7853 15.9496C14.9334 15.6733 14.5756 15.2287 14.5756 14.3394C14.5756 13.4965 15.2025 12.8986 16.4127 12.8986C17.5065 12.8986 18.1366 13.291 18.3959 14.1946C18.4542 14.3967 18.6306 14.539 18.8349 14.539H19.7966C20.064 14.539 20.2724 14.2864 20.2158 14.0178C19.9114 12.5887 18.9736 11.7314 17.5024 11.4611V9.96723C17.5024 9.70871 17.2981 9.49902 17.0453 9.49902H16.1321C15.8802 9.49902 15.6751 9.70871 15.6751 9.96723V11.4199C13.8642 11.6843 12.6934 12.9213 12.6934 14.5087C12.6934 16.5626 13.9028 17.3601 16.4571 17.7129C18.19 18.0043 18.6831 18.3866 18.6831 19.3988C18.6831 20.411 17.8462 21.0855 16.6663 21.0855C15.0712 21.0855 14.5469 20.3689 14.3533 19.4418C14.3073 19.222 14.1235 19.0611 13.9053 19.0611H12.8632C12.6006 19.0611 12.3947 19.3045 12.4398 19.5698C12.7057 21.1302 13.6821 22.2754 15.6751 22.5525V24.0329C15.6751 24.2923 15.8802 24.502 16.1321 24.502Z",
    fill: "#CBDFEF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2504 27.7217C13.5802 27.8295 13.8493 27.6291 13.8493 27.2737V26.4005C13.8493 26.1622 13.6746 25.891 13.4563 25.8093C9.95763 24.494 7.45425 21.0422 7.45425 17.0009C7.45425 12.9596 9.95763 9.50869 13.4563 8.19332C13.6746 8.11079 13.8493 7.83964 13.8493 7.60216V6.72806C13.8493 6.37353 13.5802 6.17227 13.2504 6.28006C8.8286 7.73016 5.62695 11.982 5.62695 17.0009C5.62695 22.0198 8.8286 26.2716 13.2504 27.7217Z",
    fill: "#CBDFEF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.931 6.28013C19.6012 6.17234 19.332 6.37276 19.332 6.72813V7.60139C19.332 7.83971 19.5068 8.11086 19.7242 8.19255C23.2237 9.50792 25.7271 12.9597 25.7271 17.001C25.7271 21.0422 23.2237 24.4932 19.7242 25.8085C19.4855 25.8987 19.332 26.1387 19.332 26.3997V27.2738C19.332 27.6283 19.6012 27.8296 19.931 27.7218C24.3528 26.2717 27.5544 22.0199 27.5544 17.001C27.5544 11.982 24.3528 7.73023 19.931 6.28013Z",
    fill: "#CBDFEF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.199997
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9257 1.63867L2.42969 23.6698C3.30191 25.6151 4.54087 27.3448 6.05882 28.7747L26.3854 4.56162C24.7944 3.23951 22.9442 2.23825 20.9257 1.63867Z",
    fill: "white"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.5897,
    cy: 17,
    rx: 15.5897,
    ry: 16,
    stroke: "#1B4458",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetsCoinIcon);
export default __webpack_public_path__ + "static/media/assets_coin_icon.025f9de065256038833bbeb7554f85d6.svg";
export { ForwardRef as ReactComponent };